import { useTransactionsFeesAdminMooneEarnings } from "Api/Queries/Transactions/useTransactionsFeesMooneEarnings";
import { BaseTransactionFees } from "Components/Dashboard/TransactionFees/BaseTransactionFees";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { getRegionCurrency } from "Utils/CurrencyUtils";
import { endOfMonth, startOfMonth, subMonths } from "date-fns";
import { Resources, useResource } from "Translations/Resources";

const ADMIN_FEES_RESOURCES =
  Resources.Pages.Content.Dashboard.TransactionFees.Admin;

export type FeesPeriodVariant = "allTime" | "currentMonth" | "lastMonth";

const useDateRange = (variant: FeesPeriodVariant) => {
  const targetDateByVariant: Record<FeesPeriodVariant, Date | undefined> = {
    allTime: undefined,
    currentMonth: new Date(),
    lastMonth: subMonths(new Date(), 1),
  };

  const targetDate = targetDateByVariant[variant];

  if (!targetDate) {
    return { dateFrom: undefined, dateTo: undefined };
  }

  return {
    dateFrom: startOfMonth(targetDate).toISOString(),
    dateTo: endOfMonth(targetDate).toISOString(),
  };
};

type Props = {
  variant?: FeesPeriodVariant;
};

export const AdminTransactionFees = ({ variant = "allTime" }: Props) => {
  const { dateFrom, dateTo } = useDateRange(variant);
  const { data: adminMooneEarnings, isLoading } =
    useTransactionsFeesAdminMooneEarnings(dateFrom, dateTo);
  const { t } = useResource();
  const currentUser = useLoggedInUser();

  return (
    <PrimaryPaper sx={{ py: 4 }}>
      <BaseTransactionFees
        colorVariant="success"
        isLoading={isLoading}
        emptyStateCurrency={
          currentUser?.region
            ? getRegionCurrency(currentUser.region)
            : undefined
        }
        title={t(ADMIN_FEES_RESOURCES[variant])}
        amounts={adminMooneEarnings?.totalFees ?? []}
      />
    </PrimaryPaper>
  );
};
